export default __webpack_public_path__ + "denis.500c454b.jpg";